import { render } from "./Sidebar_v2.vue?vue&type=template&id=ec788786&scoped=true&ts=true"
import script from "./Sidebar_v2.vue?vue&type=script&lang=ts"
export * from "./Sidebar_v2.vue?vue&type=script&lang=ts"

import "./Sidebar_v2.vue?vue&type=style&index=0&id=ec788786&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec788786"]])

export default __exports__